import service from "@/store/services/modelos-service";

const state = {
  list: {},
  modelo: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, modelo) => {
    state.modelo = modelo;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((modelo) => {
      commit("SET_RESOURCE", modelo);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((modelo) => {
      commit("SET_RESOURCE", modelo);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((modelo) => {
      commit("SET_RESOURCE", modelo);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.pagination.total,
  modelo: (state) => state.modelo,
  dropdown: (state) => {
    /*  state.list.map((modelo) => console.log(modelo)); */
    return state.list.map((modelo) => ({
      id: modelo.id,
      nombre: modelo.nombre,
    }));
  },
};

const modelos = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default modelos;
